import { ReactNode, useEffect, useState } from 'react';
import parse from 'html-react-parser';

import bemClassName from '../../utils/bem';

import './index.scss';
import Public from '../../API/Public';
import Loading from '../../UI/Loading';

const userAgreement = bemClassName('user-agreement');

const UserAgreement = () => {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  let parsedHTML;
  if (data) {
    parsedHTML = parse(data.content);
  }

  useEffect(() => {
    document.title = 'Пользовательское соглашение';
    setIsLoading(true);
    Public.getUserAgreement()
      .then((items) => {
        setData(items);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading externalClassName={userAgreement('loading')} />
      ) : (
        data && (
          <>
            <h2 className={userAgreement('title')}>{data.title}</h2>
            <div className={userAgreement('oferta')}>
              <div className={userAgreement('inner')}>{parsedHTML as ReactNode}</div>
            </div>
          </>
        )
      )}
    </>
  );
};

export default UserAgreement;
